import { ProductTourVuePlugin, productTour } from './productTour/index';
import { preventMinification } from '@/@core/utils/preventMinification';
import { useUserStore } from '@/stores/userStore';
import type { App } from 'vue';

/**
 * Setup function to initialize the product tour service for the assistant-ui app.
 *
 * This function handles all app-specific configuration including:
 * - Environment variable extraction
 * - Product tour plugin installation
 * - User identification setup
 *
 * @param app Vue app instance
 * @param debug Enable debug mode (optional)
 */
export async function setupProductTour(app: App, debug = false) {
  const token = preventMinification(import.meta.env.VITE_PRODUCT_TOUR_TOKEN);
  if (!token) return;

  // Install the product tour Vue plugin
  app.use(ProductTourVuePlugin, {
    token,
    debug,
  });

  // Wait for product tour service to be ready before registering user identification
  await new Promise((resolve) => setTimeout(resolve, 500));

  // Register user identification callback with the store
  const userStore = useUserStore();
  userStore.onUserIdentified((user, userId) => {
    productTour.identifyUser(userId, {
      email: user.profile.email || '',
      name: user.profile.name || '',
    });
  });
}

// Re-export productTour for use in main.ts and other app files
export { productTour };
